/* NicheGems wishlist. One file, no dependencies. Settings come from snippets/ng-wishlist-boot.liquid (window.NGW).

   Phase 0 (NGW.api empty): the list lives in this browser only (key "ng-wishlist:1": localStorage with consent
                            for preferences, sessionStorage without). Nothing is sent.
   Phase 1 (NGW.api set):   still local first. The list goes to our own worker only after the visitor gave an
                            e-mail address and ticked the box on the wishlist page; from then on changes are synced,
                            until the visitor stops (here or through the link in a mail). If the worker cannot be
                            reached, everything on the page keeps working and the sync is retried later.

   The script never writes a price. Cards on the wishlist page are rendered by Shopify (section ng-wishlist-card). */
(function () {
  'use strict';

  var C = window.NGW;
  if (!C || window.__ngwInit) return;
  window.__ngwInit = 1;

  var KEY = 'ng-wishlist:1';
  var MAX = Math.max(1, Math.min(250, Number(C.max) || 100));
  var SHARE_MAX = 40; /* perfumes in a share link: keeps the address short enough for every messenger */
  var PID = /^[0-9]{5,20}$/;
  var HANDLE = /^[a-z0-9][a-z0-9_-]{0,254}$/;
  var LIST_ID = /^[A-Za-z0-9_-]{20,44}$/;
  var EMAIL = /^[^\s@<>()"',;:\\]+@[a-z0-9](?:[a-z0-9-]*[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)+$/i;
  var doc = document;
  var T = C.t || {};
  var API = C.api ? String(C.api).replace(/\/+$/, '') : '';

  function fill(s, vars) {
    return String(s || '').replace(/\{(\w+)\}/g, function (m, k) { return vars && k in vars ? vars[k] : m; });
  }

  /* ---------- the list ----------
     { v: 1, i: [[productId, handle, savedAt, gone]], r: revision, id: list key (made only when the visitor opts in),
       on: 0 local only | 1 synced | 2 synced, waiting for the confirmation mail, d: 1 = a change is not at the worker yet,
       cap: the worker's limit of arrival requests per address when this list is over it } */
  var mem = null; /* fallback when storage is not allowed (private window) */
  var lsOk = true;

  function blank() { return { v: 1, i: [], r: 0, id: null, on: 0, d: 0, cap: 0 }; }
  function clean(raw) {
    var out = blank();
    var seen = {};
    if (!raw || typeof raw !== 'object' || !Array.isArray(raw.i)) return out;
    raw.i.forEach(function (x) {
      if (!Array.isArray(x)) return;
      var p = String(x[0]);
      var h = String(x[1] || '').toLowerCase();
      if (!PID.test(p) || !HANDLE.test(h) || seen[p] || out.i.length >= MAX) return;
      seen[p] = 1;
      var t = Math.floor(Number(x[2]));
      out.i.push([p, h, t > 0 ? t : Date.now(), x[3] ? 1 : 0]);
    });
    out.r = Number(raw.r) > 0 ? Math.floor(Number(raw.r)) : 0;
    out.id = typeof raw.id === 'string' && LIST_ID.test(raw.id) ? raw.id : null;
    out.on = out.id && (raw.on === 1 || raw.on === 2) ? raw.on : 0;
    out.d = out.on && raw.d ? 1 : 0;
    out.cap = out.on && Number(raw.cap) > 0 ? Math.floor(Number(raw.cap)) : 0;
    return out;
  }
  /* Theme builder's change to the kit (7 Oct 2026): where the list is kept follows the visitor's cookie choice,
     read from Shopify's customer privacy API, the same gate as the theme's "recently viewed".
     Consent for preferences: localStorage, the list is there on the next visit.
     No consent (declined, or the banner not answered): sessionStorage, hearts work for this visit and nothing
     is kept afterwards. A choice made or changed during the visit moves the list to the right place. */
  var persist = null; /* null = not known yet, true / false = the visitor's choice */

  function load() {
    var raw = null;
    try {
      raw = JSON.parse(window.sessionStorage.getItem(KEY) || 'null');
      if (!raw && persist !== false) raw = JSON.parse(window.localStorage.getItem(KEY) || 'null');
    } catch (e) { raw = null; lsOk = false; }
    if (!raw && !lsOk) raw = mem;
    return clean(raw);
  }
  function save(s) {
    mem = s;
    try {
      if (persist === true) window.localStorage.setItem(KEY, JSON.stringify(s));
      else window.sessionStorage.setItem(KEY, JSON.stringify(s));
      lsOk = true;
    } catch (e) { lsOk = false; }
    paint(s);
  }
  function setPersist(yes) {
    yes = !!yes;
    if (persist === yes) return;
    persist = yes;
    try {
      if (yes) {
        var visit = window.sessionStorage.getItem(KEY);
        if (visit) { window.localStorage.setItem(KEY, visit); window.sessionStorage.removeItem(KEY); }
      } else {
        var kept = window.localStorage.getItem(KEY);
        if (kept) {
          if (!window.sessionStorage.getItem(KEY)) window.sessionStorage.setItem(KEY, kept);
          window.localStorage.removeItem(KEY);
        }
      }
    } catch (e) {}
    paint(load());
  }
  function askConsent() {
    var S = window.Shopify;
    function allowed() {
      try { return !!(S.customerPrivacy && S.customerPrivacy.preferencesProcessingAllowed()); } catch (e) { return false; }
    }
    if (S && S.customerPrivacy) { setPersist(allowed()); return; }
    if (S && typeof S.loadFeatures === 'function') {
      S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) { setPersist(!error && allowed()); });
      return;
    }
    setPersist(false);
  }
  doc.addEventListener('visitorConsentCollected', function (e) { setPersist(!!(e.detail && e.detail.preferencesAllowed)); });
  function at(s, pid) {
    for (var k = 0; k < s.i.length; k++) if (s.i[k][0] === pid) return k;
    return -1;
  }
  function visible(s) {
    return s.i.filter(function (x) { return !x[3]; }).sort(function (a, b) { return b[2] - a[2]; });
  }
  function touch(s) {
    s.r += 1;
    if (s.on) s.d = 1;
  }
  /* -> 'added' | 'has' | 'full' | 'bad' */
  function add(s, pid, handle, t) {
    pid = String(pid);
    handle = String(handle || '').toLowerCase();
    if (!PID.test(pid) || !HANDLE.test(handle)) return 'bad';
    var k = at(s, pid);
    if (k >= 0) {
      if (!s.i[k][3]) return 'has';
      s.i[k][3] = 0; /* was hidden as "no longer in the shop": the visitor saved it again */
      s.i[k][1] = handle;
      touch(s);
      return 'added';
    }
    if (s.i.length >= MAX) return 'full';
    s.i.push([pid, handle, t > 0 ? Math.floor(t) : Date.now(), 0]);
    touch(s);
    return 'added';
  }
  function drop(s, pid) {
    var k = at(s, String(pid));
    if (k < 0) return null;
    var it = s.i.splice(k, 1)[0];
    touch(s);
    return it;
  }

  /* ---------- network (XMLHttpRequest: shop apps like to wrap window.fetch) ---------- */
  function xhr(method, url, body, cb) {
    var x;
    try {
      x = new XMLHttpRequest();
      x.open(method, url, true);
      x.timeout = 12000;
      if (body) x.setRequestHeader('Content-Type', 'application/json');
      x.onload = function () {
        var j = null;
        try { j = JSON.parse(x.responseText); } catch (e) { j = null; }
        cb(x.status, j, x.responseText);
      };
      x.onerror = x.ontimeout = function () { cb(0, null, ''); };
      x.send(body ? JSON.stringify(body) : null);
    } catch (e) {
      cb(0, null, '');
    }
  }
  function rootPath(p) { return String(C.root || '/').replace(/\/$/, '') + p; }
  function newId() {
    var a = new Uint8Array(16);
    (window.crypto || window.msCrypto).getRandomValues(a);
    var s = '';
    for (var k = 0; k < a.length; k++) s += String.fromCharCode(a[k]);
    return window.btoa(s).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function wire(s) {
    return visible(s).map(function (x) { return [x[0], x[1], x[2]]; });
  }

  /* ---------- phase 1: sync with the worker, only for a list the visitor opted in ---------- */
  var timer = null;
  var busy = false;
  var again = false;
  var waiters = [];
  var onEnded = null; /* set by the wishlist page: the worker says this list is no longer kept there */

  function syncSoon() {
    if (!API) return;
    window.clearTimeout(timer);
    timer = window.setTimeout(function () { sync(); }, 900);
  }
  function sync(cb) {
    var s = load();
    if (cb) waiters.push(cb);
    if (!API || !s.on || !s.id) return done(s, 0);
    if (busy) { again = true; return; }
    busy = true;
    var sentRev = s.r;
    xhr('POST', API + '/v1/wish', { s: C.s, do: 'sync', id: s.id, rev: s.r, loc: C.loc, items: wire(s) }, function (st, j) {
      busy = false;
      var cur = load();
      var ended = false;
      if (st === 200 && j && j.ok) {
        if (!j.on) {
          /* stopped through the link in a mail, expired, or erased on request: back to a local list */
          ended = cur.on > 0;
          cur.on = 0; cur.id = null; cur.d = 0; cur.cap = 0;
        } else {
          cur.on = j.confirm ? 2 : 1;
          cur.cap = j.cap > 0 && j.n > j.cap ? Math.floor(j.cap) : 0;
          if (cur.r === sentRev) cur.d = 0;
        }
        save(cur);
      }
      /* no answer, 429 or 5xx: "d" stays 1 and the next page view or change tries again */
      done(cur, st);
      if (ended && onEnded) onEnded();
      if (again) { again = false; syncSoon(); }
    });
  }
  function done(s, status) {
    var list = waiters;
    waiters = [];
    list.forEach(function (f) { try { f(s, status); } catch (e) {} });
  }
  /* cb(error | null): error is 'invalid' | 'rate' | 'error' */
  function optIn(email, cb) {
    var s = load();
    if (!API) return cb('error');
    if (!s.id) {
      /* kept before the request goes out: a retry after a lost answer reuses the same list at the worker */
      s.id = newId();
      save(s);
    }
    var sentRev = s.r;
    xhr('POST', API + '/v1/wish', { s: C.s, do: 'on', id: s.id, email: email, tick: 1, cv: C.cv, loc: C.loc, rev: s.r, items: wire(s) }, function (st, j) {
      if (st === 200 && j && j.ok && j.on) {
        var cur = load();
        cur.id = s.id;
        cur.on = j.confirm ? 2 : 1;
        cur.cap = j.cap > 0 && j.n > j.cap ? Math.floor(j.cap) : 0;
        cur.d = cur.r === sentRev ? 0 : 1;
        save(cur);
        if (cur.d) syncSoon();
        return cb(null);
      }
      cb(st === 422 ? 'invalid' : st === 429 ? 'rate' : 'error');
    });
  }
  function optOut(cb) {
    var s = load();
    var forget = function () {
      var cur = load();
      cur.on = 0; cur.id = null; cur.d = 0; cur.cap = 0;
      save(cur);
      cb(null);
    };
    if (!API || !s.id) return forget();
    xhr('POST', API + '/v1/wish', { s: C.s, do: 'off', id: s.id }, function (st, j) {
      if (st === 200 && j && j.ok) return forget();
      cb(st === 429 ? 'rate' : 'error'); /* not confirmed by the worker: do not claim the address is gone */
    });
  }
  /* optional, off by default: one anonymous +1 / -1 per perfume. No list key, no address. */
  function tap(pid, handle, d) {
    if (API && C.taps) xhr('POST', API + '/v1/wish', { s: C.s, do: 'tap', p: pid, h: handle, d: d }, function () {});
  }

  /* ---------- hearts, counter, toast ---------- */
  function label(btn, s) {
    var k = at(s, btn.getAttribute('data-ng-wishlist'));
    var on = k >= 0 && !s.i[k][3];
    var title = btn.getAttribute('data-title');
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', (on ? T.remove : T.save) + (title ? ': ' + title : ''));
  }
  function each(sel, fn, root) { Array.prototype.forEach.call((root || doc).querySelectorAll(sel), fn); }
  function paint(s) {
    if (C.paint) C.paint(s.i);
    var n = visible(s).length;
    each('[data-ng-wishlist]', function (b) { label(b, s); });
    each('[data-ng-wishlist-link]', function (a) {
      var base = a.getAttribute('data-label') || T.title || '';
      if (a.hasAttribute('aria-label')) a.setAttribute('aria-label', n ? base + ' (' + n + ')' : base);
      var num = a.querySelector('[data-ng-wishlist-n]');
      if (num) { num.textContent = n > 99 ? '99+' : String(n); num.hidden = !n; }
    });
    listeners.forEach(function (f) { try { f(s); } catch (e) {} });
  }
  var listeners = [];

  var toastEl = null;
  var toastTimer = null;
  /* action: { text, href } or { text, fn } */
  function toast(text, action) {
    if (toastEl && toastEl.parentNode) toastEl.parentNode.removeChild(toastEl);
    window.clearTimeout(toastTimer);
    var el = doc.createElement('div');
    el.className = 'ng-wishlist-toast';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    var span = doc.createElement('span');
    span.textContent = text;
    el.appendChild(span);
    if (action && action.text) {
      var a = doc.createElement(action.href ? 'a' : 'button');
      if (action.href) a.setAttribute('href', action.href);
      else {
        a.setAttribute('type', 'button');
        a.addEventListener('click', function () { hide(); action.fn(); });
      }
      a.textContent = action.text;
      el.appendChild(a);
    }
    function hide() {
      el.classList.remove('ng-wishlist-toast--in');
      window.setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); if (toastEl === el) toastEl = null; }, 250);
    }
    doc.body.appendChild(el);
    toastEl = el;
    (window.requestAnimationFrame || window.setTimeout)(function () { el.classList.add('ng-wishlist-toast--in'); });
    toastTimer = window.setTimeout(hide, action && action.fn ? 7000 : 4500);
  }

  function changed() {
    var s = load();
    if (s.on) syncSoon();
  }
  function restore(item) {
    var s = load();
    if (add(s, item[0], item[1], item[2]) === 'added') { save(s); changed(); tap(item[0], item[1], 1); }
  }
  /* a tap on a heart, anywhere on the site */
  function onHeart(btn) {
    var pid = String(btn.getAttribute('data-ng-wishlist') || '');
    var handle = String(btn.getAttribute('data-handle') || '').toLowerCase();
    var s = load();
    var k = at(s, pid);
    if (k >= 0 && !s.i[k][3]) {
      var item = drop(s, pid);
      save(s);
      changed();
      tap(pid, handle, -1);
      toast(T.toast_removed, { text: T.undo, fn: function () { restore(item); } });
      return;
    }
    var res = add(s, pid, handle, Date.now());
    if (res === 'full') return toast(fill(T.full, { n: MAX }));
    if (res !== 'added') return;
    save(s);
    changed();
    tap(pid, handle, 1);
    btn.classList.add('ng-wishlist-btn--pop');
    window.setTimeout(function () { btn.classList.remove('ng-wishlist-btn--pop'); }, 400);
    toast(T.toast_saved, onPage ? null : { text: T.view, href: C.page });
  }

  var onPage = false;
  doc.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('[data-ng-wishlist]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    onHeart(btn);
  });
  /* cards that arrive later (rails, search, filters) get their label the moment someone reaches them */
  ['pointerdown', 'focusin'].forEach(function (type) {
    doc.addEventListener(type, function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-ng-wishlist]') : null;
      if (btn) label(btn, load());
    }, true);
  });

  /* ---------- share link: /pages/wishlist#l=handle,handle  (the part behind # never leaves the browser) ---------- */
  function shareUrl(s) {
    var handles = visible(s).slice(0, SHARE_MAX).map(function (x) { return x[1]; });
    return window.location.origin + C.page + '#l=' + handles.join(',');
  }
  function parseShared(hash) {
    var m = /^#l=([a-z0-9_,-]{1,12000})$/.exec(String(hash || ''));
    if (!m) return null;
    var seen = {};
    var out = [];
    m[1].split(',').forEach(function (h) {
      if (HANDLE.test(h) && !seen[h] && out.length < SHARE_MAX) { seen[h] = 1; out.push(h); }
    });
    return out;
  }

  /* ---------- the wishlist page ---------- */
  function initPage(root) {
    if (root.getAttribute('data-ngw-ready')) return;
    root.setAttribute('data-ngw-ready', '1');
    onPage = true;

    var P = {};
    try { P = JSON.parse(root.querySelector('[data-ngw-strings]').textContent) || {}; } catch (e) { P = {}; }
    var q = function (sel) { return root.querySelector(sel); };
    var grid = q('[data-ngw-grid]');
    if (!grid) return;
    var countEl = q('[data-ngw-count]');
    var empty = q('[data-ngw-empty]');
    var tools = q('[data-ngw-tools]');
    var sharedBox = q('[data-ngw-shared]');
    var loading = q('[data-ngw-loading]');
    var where = q('[data-ngw-where]');
    var shared = parseShared(window.location.hash);
    var pending = 0;
    var show = function (el, on) { if (el) el.hidden = !on; };

    function cardCount() { return grid.querySelectorAll('[data-ng-wishlist-item]').length; }
    function settle() {
      var s = load();
      var n = shared ? cardCount() : visible(s).length;
      if (countEl) countEl.textContent = n === 1 ? P.count_one : fill(P.count_many, { n: n });
      show(countEl, n > 0);
      show(loading, pending > 0 && cardCount() === 0);
      show(empty, n === 0 && pending === 0);
      show(tools, !shared && n > 0);
      show(sharedBox, !!shared);
      var saveAll = q('[data-ngw-save-all]');
      show(saveAll, !!shared && n > 0);
      if (where) where.textContent = s.on ? P.local_on : P.local;
      paintArrive();
    }

    /* one card: ask Shopify for it, in the visitor's language. 404 = the perfume is no longer in the shop. */
    var queue = [];
    var running = 0;
    function slotFor(key) {
      var li = doc.createElement('li');
      li.className = 'ng-wishlist__item ng-wishlist__item--wait';
      li.setAttribute('data-ngw-slot', key);
      return li;
    }
    function pump() {
      while (running < 3 && queue.length) run(queue.shift());
    }
    function run(job) {
      running++;
      xhr('GET', rootPath('/products/' + encodeURIComponent(job.handle)) + '?section_id=ng-wishlist-card', null, function (st, j, text) {
        running--;
        pending--;
        var li = null;
        if (st === 200 && text) {
          var box = doc.createElement('div');
          box.innerHTML = text;
          li = box.querySelector('[data-ng-wishlist-item]');
        }
        var inList = !job.pid || at(load(), job.pid) >= 0; /* removed while the card was on its way */
        var match = !!li && (!job.pid || li.getAttribute('data-ng-wishlist-item') === job.pid);
        if (match && inList && job.slot.parentNode) {
          job.slot.parentNode.replaceChild(li, job.slot);
          if (job.pid) gone(job.pid, 0);
          each('[data-ng-wishlist]', function (b) { label(b, load()); }, li);
        } else {
          if (job.slot.parentNode) job.slot.parentNode.removeChild(job.slot);
          /* Only a clear "not found" (404, or the handle now belongs to another product) hides a perfume from
             the count. A hiccup, or a card that arrived after the grid was rebuilt, leaves the list as it is. */
          if (job.pid && inList && (st === 404 || (st === 200 && !!li && !match))) gone(job.pid, 1);
        }
        settle();
        pump();
      });
    }
    function gone(pid, flag) {
      var s = load();
      var k = at(s, pid);
      if (k < 0 || s.i[k][3] === flag) return;
      s.i[k][3] = flag;
      save(s); /* a display flag: no new revision, nothing to sync */
    }
    function want(pid, handle, before) {
      var slot = slotFor(pid || 'h:' + handle);
      if (before) grid.insertBefore(slot, before);
      else grid.appendChild(slot);
      pending++;
      queue.push({ pid: pid, handle: handle, slot: slot });
    }
    function build() {
      queue = [];
      pending = running; /* answers still on their way are counted down when they land */
      grid.innerHTML = '';
      if (shared) shared.forEach(function (h) { want(null, h); });
      else {
        /* everything on the list, also what was hidden as "not found": it may be back */
        load().i.slice().sort(function (a, b) { return b[2] - a[2]; }).forEach(function (x) { want(x[0], x[1]); });
      }
      settle();
      pump();
    }

    /* ----- own list: remove with undo, clear, share ----- */
    root.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target : null;
      if (!t) return;
      var rm = t.closest('[data-ng-wishlist-remove]');
      if (rm && !shared) {
        e.preventDefault();
        var pid = String(rm.getAttribute('data-ng-wishlist-remove'));
        var li = rm.closest('[data-ng-wishlist-item]');
        var s = load();
        var item = drop(s, pid);
        if (!item) return;
        save(s);
        changed();
        tap(item[0], item[1], -1);
        var next = li ? li.nextElementSibling : null;
        if (li) {
          li.classList.add('ng-wishlist__item--out');
          window.setTimeout(function () { if (li.parentNode) li.parentNode.removeChild(li); settle(); }, 200);
        }
        settle();
        toast(T.toast_removed, {
          text: T.undo,
          fn: function () {
            var cur = load();
            if (add(cur, item[0], item[1], item[2]) !== 'added') return;
            save(cur);
            changed();
            tap(item[0], item[1], 1);
            want(item[0], item[1], next && next.parentNode === grid ? next : null);
            settle();
            pump();
          },
        });
        return;
      }
      if (t.closest('[data-ngw-clear]')) return clearList(t.closest('[data-ngw-clear]'));
      if (t.closest('[data-ngw-share]')) return share();
      if (t.closest('[data-ngw-save-all]')) return saveAll();
      if (t.closest('[data-ngw-arrive-off]')) return arriveOff(t.closest('[data-ngw-arrive-off]'));
    });

    var clearTimer = null;
    function clearList(btn) {
      if (!btn.getAttribute('data-armed')) {
        /* two steps instead of a browser dialog: the second tap within five seconds does it */
        btn.setAttribute('data-armed', '1');
        btn.textContent = P.clear_yes;
        clearTimer = window.setTimeout(function () { btn.removeAttribute('data-armed'); btn.textContent = P.clear; }, 5000);
        return;
      }
      window.clearTimeout(clearTimer);
      btn.removeAttribute('data-armed');
      btn.textContent = P.clear;
      var s = load();
      var old = visible(s);
      if (!s.i.length) return;
      s.i = [];
      touch(s);
      save(s);
      changed();
      old.forEach(function (x) { tap(x[0], x[1], -1); });
      queue = [];
      pending = running;
      grid.innerHTML = '';
      settle();
      toast(P.cleared);
    }
    function share() {
      var s = load();
      var n = visible(s).length;
      if (!n) return;
      var url = shareUrl(s);
      var note = q('[data-ngw-share-note]');
      if (note) { note.textContent = fill(P.share_cut, { n: SHARE_MAX }); note.hidden = n <= SHARE_MAX; }
      var copy = function () {
        if (window.navigator.clipboard && window.navigator.clipboard.writeText) {
          window.navigator.clipboard.writeText(url).then(function () { toast(P.share_copied); }, function () { window.prompt(P.share_prompt, url); });
        } else window.prompt(P.share_prompt, url);
      };
      if (window.navigator.share && window.matchMedia && window.matchMedia('(pointer: coarse)').matches) {
        window.navigator.share({ title: fill(P.share_msg, { shop: C.shop || 'NicheGems' }), url: url }).catch(function (err) {
          if (!err || err.name !== 'AbortError') copy();
        });
      } else copy();
    }
    function saveAll() {
      var s = load();
      var n = 0;
      var full = false;
      each('[data-ng-wishlist-item]', function (li) {
        var res = add(s, li.getAttribute('data-ng-wishlist-item'), li.getAttribute('data-handle'), Date.now() - n);
        if (res === 'added') { n++; tap(li.getAttribute('data-ng-wishlist-item'), li.getAttribute('data-handle'), 1); }
        if (res === 'full') full = true;
      }, grid);
      if (n) { save(s); changed(); }
      if (full && !n) return toast(fill(T.full, { n: MAX }));
      toast(n ? fill(P.shared_saved, { n: n }) : P.shared_none, { text: T.view, href: C.page });
    }

    /* ----- "Hear when they arrive" (phase 1 only) ----- */
    var arr = q('[data-ngw-arrive]');
    var form = q('[data-ngw-arrive-form]');
    var onBox = q('[data-ngw-arrive-on]');
    var statusEl = q('[data-ngw-arrive-status]');
    var capEl = q('[data-ngw-arrive-cap]');
    var errEl = q('[data-ngw-arrive-error]');
    var submit = q('[data-ngw-arrive-submit]');
    var tick = q('[data-ngw-arrive-tick]');
    var input = form ? form.querySelector('input[type="email"]') : null;

    function paintArrive() {
      if (!arr) return;
      var s = load();
      if (!API || shared || !form || !onBox) return show(arr, false);
      show(arr, visible(s).length > 0 || s.on > 0);
      show(form, !s.on);
      show(onBox, s.on > 0);
      if (statusEl && s.on) statusEl.textContent = s.on === 2 ? P.arr_confirm : P.arr_on;
      if (capEl) { capEl.textContent = fill(P.arr_cap, { n: s.cap }); capEl.hidden = !(s.on && s.cap); }
    }
    function arriveError(text) {
      if (!errEl) return;
      errEl.textContent = text || '';
      errEl.hidden = !text;
    }
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        arriveError('');
        var email = input ? String(input.value || '').trim() : '';
        if (!EMAIL.test(email) || email.length > 254) { arriveError(P.arr_invalid); if (input) input.focus(); return; }
        /* the box is never ticked for the visitor: without it nothing is sent */
        if (!tick || !tick.checked) { arriveError(P.arr_need_tick); if (tick) tick.focus(); return; }
        var text = submit ? submit.textContent : '';
        if (submit) { submit.disabled = true; submit.textContent = P.arr_wait || text; }
        optIn(email, function (err) {
          if (submit) { submit.disabled = false; submit.textContent = text; }
          if (err) return arriveError(err === 'invalid' ? P.arr_invalid : err === 'rate' ? P.arr_rate : P.arr_error);
          if (input) input.value = '';
          if (tick) tick.checked = false;
          settle();
        });
      });
    }
    function arriveOff(btn) {
      btn.disabled = true;
      optOut(function (err) {
        btn.disabled = false;
        if (err) return toast(err === 'rate' ? P.arr_rate : P.arr_error);
        settle();
        toast(P.arr_stopped);
      });
    }
    onEnded = function () { settle(); toast(P.arr_ended); };

    /* ----- start ----- */
    if (shared) {
      root.classList.add('ng-wishlist--shared');
      var eb = q('[data-ngw-eyebrow]');
      var hd = q('[data-ngw-heading]');
      if (eb) eb.textContent = P.shared_eyebrow;
      if (hd) hd.textContent = P.shared_heading;
      var et = q('[data-ngw-empty-title]');
      var ex = q('[data-ngw-empty-text]');
      if (et) et.textContent = P.shared_empty;
      if (ex) ex.hidden = true;
    }
    build();
    /* a synced list: tell the worker what is here and hear whether the list is still kept there */
    if (!shared && API && load().on) sync(function () { settle(); });
    /* the list changed in another tab */
    listeners.push(function () { if (!building) settle(); });
    window.addEventListener('storage', function (e) {
      if (e.key !== KEY || shared) return;
      building = true;
      paint(load());
      building = false;
      build();
    });
    /* "my own list" on a shared link, or a new shared link pasted into this tab */
    window.addEventListener('hashchange', function () { window.location.reload(); });
  }
  var building = false;

  function start() {
    var s = load();
    paint(s);
    askConsent();
    each('[data-ng-wishlist-page]', initPage);
    /* a change that did not reach the worker last time */
    if (API && s.on && s.d && !onPage) syncSoon();
  }
  if (doc.readyState !== 'loading') start();
  else doc.addEventListener('DOMContentLoaded', start);
  window.addEventListener('pageshow', function (e) { if (e.persisted) paint(load()); });
  window.addEventListener('storage', function (e) { if (e.key === KEY && !onPage) paint(load()); });
  doc.addEventListener('shopify:section:load', function (e) {
    paint(load());
    if (e.target && e.target.querySelectorAll) each('[data-ng-wishlist-page]', initPage, e.target);
  });

  /* for the theme and for the tests */
  C.list = function () { return visible(load()).map(function (x) { return { id: x[0], handle: x[1], at: x[2] }; }); };
  C._ = { KEY: KEY, MAX: MAX, SHARE_MAX: SHARE_MAX, load: load, save: save, add: add, drop: drop, visible: visible, sync: sync, optIn: optIn, optOut: optOut, shareUrl: shareUrl, parseShared: parseShared, onHeart: onHeart, clean: clean };
})();
